(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/draw.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/draw.js'); 
'use strict';

svs.maltipset.models.Draw = Backbone.Model.extend({
  initialize: function() {
    this.set(
      'matchList',
      new svs.maltipset.collections.MatchList(this.get('drawEvents'), {
        silent: false
      })
    );
    this.unset('drawEvents');

    if (this.isOpen()) {
      this.set('jackpot', svs.maltipset.data.jackpot, { silent: true });
      this.set('currentJackpot', svs.maltipset.data.jackpotAmount, {
        silent: true
      });
    }
  },
  isOpen: function() {
    return this.get('drawState') === 'Open';
  },

  hasMatchData: function() {
    return this.get('matchList').hasMatchData();
  }
});

 })(window);